__turbopack_context__.v({
  "actionButton": "askAiChat-module-scss-module__Rx0gua__actionButton",
  "assistantMessage": "askAiChat-module-scss-module__Rx0gua__assistantMessage",
  "assistantMessageFailed": "askAiChat-module-scss-module__Rx0gua__assistantMessageFailed",
  "chat": "askAiChat-module-scss-module__Rx0gua__chat",
  "composer": "askAiChat-module-scss-module__Rx0gua__composer",
  "composerField": "askAiChat-module-scss-module__Rx0gua__composerField",
  "connectionError": "askAiChat-module-scss-module__Rx0gua__connectionError",
  "dateLabel": "askAiChat-module-scss-module__Rx0gua__dateLabel",
  "disclaimer": "askAiChat-module-scss-module__Rx0gua__disclaimer",
  "downloadButton": "askAiChat-module-scss-module__Rx0gua__downloadButton",
  "errorActions": "askAiChat-module-scss-module__Rx0gua__errorActions",
  "errorIcon": "askAiChat-module-scss-module__Rx0gua__errorIcon",
  "errorText": "askAiChat-module-scss-module__Rx0gua__errorText",
  "inlineExportButton": "askAiChat-module-scss-module__Rx0gua__inlineExportButton",
  "markdownCode": "askAiChat-module-scss-module__Rx0gua__markdownCode",
  "markdownHeading": "askAiChat-module-scss-module__Rx0gua__markdownHeading",
  "markdownLink": "askAiChat-module-scss-module__Rx0gua__markdownLink",
  "markdownList": "askAiChat-module-scss-module__Rx0gua__markdownList",
  "markdownListItem": "askAiChat-module-scss-module__Rx0gua__markdownListItem",
  "markdownTable": "askAiChat-module-scss-module__Rx0gua__markdownTable",
  "markdownTableBlock": "askAiChat-module-scss-module__Rx0gua__markdownTableBlock",
  "markdownTableWrp": "askAiChat-module-scss-module__Rx0gua__markdownTableWrp",
  "markdownTd": "askAiChat-module-scss-module__Rx0gua__markdownTd",
  "markdownTh": "askAiChat-module-scss-module__Rx0gua__markdownTh",
  "messageActions": "askAiChat-module-scss-module__Rx0gua__messageActions",
  "messageActionsLabel": "askAiChat-module-scss-module__Rx0gua__messageActionsLabel",
  "processing": "askAiChat-module-scss-module__Rx0gua__processing",
  "processingCurrent": "askAiChat-module-scss-module__Rx0gua__processingCurrent",
  "processingIcon": "askAiChat-module-scss-module__Rx0gua__processingIcon",
  "processingLabel": "askAiChat-module-scss-module__Rx0gua__processingLabel",
  "processingLabelFadeIn": "askAiChat-module-scss-module__Rx0gua__processingLabelFadeIn",
  "processingLines": "askAiChat-module-scss-module__Rx0gua__processingLines",
  "promptControls": "askAiChat-module-scss-module__Rx0gua__promptControls",
  "promptTag": "askAiChat-module-scss-module__Rx0gua__promptTag",
  "promptTagLabel": "askAiChat-module-scss-module__Rx0gua__promptTagLabel",
  "scroller": "askAiChat-module-scss-module__Rx0gua__scroller",
  "sendButton": "askAiChat-module-scss-module__Rx0gua__sendButton",
  "sendIcon": "askAiChat-module-scss-module__Rx0gua__sendIcon",
  "stoppedNote": "askAiChat-module-scss-module__Rx0gua__stoppedNote",
  "tableControls": "askAiChat-module-scss-module__Rx0gua__tableControls",
  "textarea": "askAiChat-module-scss-module__Rx0gua__textarea",
  "textareaField": "askAiChat-module-scss-module__Rx0gua__textareaField",
  "userMessage": "askAiChat-module-scss-module__Rx0gua__userMessage",
  "zeroCase": "askAiChat-module-scss-module__Rx0gua__zeroCase",
  "zeroCaseGreeting": "askAiChat-module-scss-module__Rx0gua__zeroCaseGreeting",
  "zeroCaseIcon": "askAiChat-module-scss-module__Rx0gua__zeroCaseIcon",
  "zeroCasePrompts": "askAiChat-module-scss-module__Rx0gua__zeroCasePrompts",
  "zeroCaseText": "askAiChat-module-scss-module__Rx0gua__zeroCaseText",
});
